import React from "react"
import Markdown from "markdown-to-jsx"
import { LinkModalContextProvider, LinkToModal, ModalFromLink } from "components/views/LinkModal"
import { createErrorBoundary } from "./createErrorBoundary"
import { TextLink } from "@carrotfertility/carotene"
import { contentValidator } from "components/dynamic-content/util/contentValidation"

const ErrorElement = () => (
  <>
    <p className="lh-copy gotham black-80 mt0 mb3">
      <strong className="b">Something’s not working</strong>
    </p>
    <p className="lh-copy gotham black-80 mt0 mb3">
      Try reloading the page. If the problem persists, feel free to{" "}
      <TextLink to={"mailto:support@get-carrot.com"}>contact us.</TextLink>
    </p>
  </>
)

const MarkdownErrorBoundary = createErrorBoundary(ErrorElement)

export const getCompiler = (elements, components) => {
  // eslint-disable-next-line react/display-name
  return (markdownString) => {
    const validateContentSource = (source) => {
      const customMarkdownTags = components
        ? Object.keys(components).filter((markdownKey) => markdownKey.charAt(0) === markdownKey.charAt(0).toUpperCase())
        : []
      return contentValidator(source, customMarkdownTags)
    }
    return (
      <MarkdownErrorBoundary>
        <LinkModalContextProvider>
          <Markdown
            options={{
              overrides: {
                ...elements,
                ...components,
                LinkToModal(props) {
                  return <LinkToModal {...props} />
                },
                ModalFromLink(props) {
                  return <ModalFromLink {...props} />
                }
              },
              forceBlock: true
            }}
          >
            {validateContentSource(markdownString)}
          </Markdown>
        </LinkModalContextProvider>
      </MarkdownErrorBoundary>
    )
  }
}
